import React from 'react';
import { useTranslation } from 'react-i18next';

import { LanguageSwitcher } from '../../../../components/shared/LanguageSwitcher';

import styles from './LanguageSettings.module.scss';

const LanguageSettings = () => {
  const { t } = useTranslation('common');

  return (
    <div className={styles.container}>
      <p className={styles.contentHeading}>{t('account.languageSettings')}</p>
      <p className={styles.description}>{t('account.languageDescription')}</p>
      <div className={styles.switcherContainer}>
        <LanguageSwitcher variant="dropdown" showFlag showName />
      </div>
    </div>
  );
};

export default LanguageSettings;
